import { FC, ReactElement } from 'react'
import type { MessageNotificationProps } from 'stream-chat-react'

import { Badge, Icon } from '@/components'
import { trans } from '@/helpers/trans'

import './ScrollToBottomButton.scss'

export const ScrollToBottomButton: FC<MessageNotificationProps> = ({
    onClick,
    showNotification = true,
    unreadCount,
}): ReactElement | null => {
    if (! showNotification) {
        return null
    }

    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={trans('pages.messages.scrollToBottom')}
            className="scroll-to-bottom-button"
        >
            <Icon name="chevron-down" className="scroll-to-bottom-button__icon" />
            {!! unreadCount && (
                <Badge value={unreadCount} className="scroll-to-bottom-button__badge" />
            )}
        </button>
    )
}
